module.exports = __webpack_public_path__ + "img/arrow.dcf4ec80.svg";